import { render, staticRenderFns } from "./EmployeeCloseTill.template.vue?vue&type=template&id=2b2d476a&scoped=true&"
var script = {}
import style0 from "./EmployeeCloseTill.template.vue?vue&type=style&index=0&id=2b2d476a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2d476a",
  null
  
)

export default component.exports